<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row">
            <div class="col-md-12">
                <x-input v-model="form.description"
                         label="Descripción del motivo de anulación"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit" text="Anular"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>
import XModal from "../../../components/XModal.vue";
import XButtonCancel from "../../../components/Form/XButtonCancel.vue";
import XButtonSubmit from "../../../components/Form/XButtonSubmit.vue";
import XInput from "../../../components/Form/XInput.vue";

export default {
    components: {XInput, XButtonSubmit, XButtonCancel, XModal},
    props: ['showDialog', 'record', 'resource'],
    data() {
        return {
            title: null,
            loading: false,
            errors: {},
            form: {},
        }
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.loading = false
            this.errors = {}
            this.form = {
                id: null,
                description: null,
            }
        },
        handleOpen() {
            this.initForm()
            this.form.id = this.record.id

            if (this.resource === 'quotations') {
                this.title = 'Cotización: '
            }
            if (this.resource === 'order_notes') {
                this.title = 'Pedido: '
            }
            if (this.resource === 'sale-notes') {
                this.title = 'Nota de venta: '
            }
            if (this.resource === 'documents') {
                this.title = 'Comprobante: '
            }
            if (this.resource === 'dispatches') {
                this.title = 'Guía de remisión: '
            }
            this.title += this.record.number_full
        },
        onSubmit() {
            if(this.form.description === '' || this.form.description === null) {
                return this.$message.error('La descripción de la anulación es requerida');
            }
            this.loading = true
            this.$http.post(`/${this.resource}/voided`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$eventHub.$emit('reloadData')
                        this.$message.success(response.data.message)
                        this.clickClose()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
